import * as React from "react";

export const AlertIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#F9709A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M32 19.2V32M32 41.6zM32 54.4c12.37 0 22.4-10.03 22.4-22.4C54.4 19.628 44.37 9.6 32 9.6 19.628 9.6 9.6 19.628 9.6 32c0 12.37 10.028 22.4 22.4 22.4"
    ></path>
  </svg>
);
